import { useAtom } from 'jotai';
import { editChildMutationAtom } from '@/features/shared/features/addOrEditChild/model';

export const useEditChild = () => {
    const [{ mutate, status, reset, error }] = useAtom(editChildMutationAtom);

    return {
        mutate,
        status,
        reset,
        errorMessage: error instanceof Error ? error.message : null,
    };
};
